import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { isEmpty, openModalMensaje, ngClassAceptarModal, ngClassSalirModal, PERSONA_EXTERNA, PERSONA_MAESTRA, openModalMensajePrg } from 'src/app/general/variables';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { PersonaXRepLeg } from 'src/app/models/PersonaXRepLeg';
import { PersonaService } from 'src/app/services/persona.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Persona } from 'src/app/models/Persona';
import { ExternosService } from 'src/app/services/externos/externos.service';

@Component({
  selector: 'app-modal-rep-legal',
  templateUrl: './modal-rep-legal.component.html',
  styleUrls: ['./modal-rep-legal.component.css']
})
export class ModalRepLegalComponent implements OnInit {

  strDscNombreCompl = '';
  strDscTitulo = 'Representante Legal';
  listRL: PersonaXRepLeg[] = [];
  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;
  strNroDoc = '';
  flgDeshabilitaValidar = false;

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(public dialogRef: MatDialogRef<ModalRepLegalComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private personaService: PersonaService,
              private spinner: NgxSpinnerService,
              private externoService: ExternosService
    ) { }

  ngOnInit() {

    this.navModalC.setDatosNavModal2(this.strDscTitulo);

    this.listRL = this.data.listModal;

  }

  _mayusculas(e) {

  let vData = '';
  const re = /^[A-Za-z, ,á-ü,Á-Ü]+$/;
  // let re = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g;
  let valor = '';

  for (let index = 0; index < e.target.value.length; index++) {

    const element = e.target.value.substr(index, 1);

    if (re.test(element) == true) {

      valor = valor + element;

    }

  }

  e.target.value = valor.toUpperCase();

  // if(re.test(e.target.value) == false)
  // {

  //   e.target.value = e.target.value.substr(0,e.target.value.length - 1);

  // }else{

  //   e.target.value = e.target.value.toUpperCase();

  // }

  // console.log(e);


  vData = e.target.value; // .trim();

  e.target.value = vData;

  this.strDscNombreCompl = vData;

 }

 _cambioNroDoc() {

  this.strDscNombreCompl = '';

 }

 obtenerPersonaXNumeroDocumento() {

  const dni =  this.strNroDoc; // this.formFuncionario.get('input_nroDoc').value;
  const tipoDoc =  '1'; // this.formFuncionario.get('select_tipoDoc').value;


  if (dni != null) {

    if (dni.length == 8) {

      this.flgDeshabilitaValidar = true;

      this.spinner.show();

      this.personaService.obtenerPersona(tipoDoc, dni).subscribe(personaMa => {

            const resultadoMa: Persona = JSON.parse(JSON.stringify(personaMa));

            this.spinner.hide();

            // console.log("=======resultadoMa",resultadoMa);

            if (resultadoMa == null) {

                this.spinner.show();

                this.externoService.obtenerPersonaXDniReniec(dni).subscribe(data => {

                    const resultado = JSON.parse(JSON.stringify(data));

                    this.spinner.hide();

                    this.llenarPersonaBusqueda(resultado, tipoDoc, PERSONA_EXTERNA);

                    this.flgDeshabilitaValidar = false;

                }, error => {

                    this.spinner.hide();

                    console.log(error);

                    this._validaDNI();



                });
              } else {

                if (resultadoMa.cpersonaNombres == null || resultadoMa.cpersonaApepaterno == null || resultadoMa.cpersonaApematerno == null) {

                  this.spinner.show();

                  this.externoService.obtenerPersonaXDniReniec(dni).subscribe(data => {

                    const resultado = JSON.parse(JSON.stringify(data));

                    this.spinner.hide();

                    this.llenarPersonaBusqueda(resultado, tipoDoc, PERSONA_EXTERNA);

                    this.flgDeshabilitaValidar = false;
                  }, error => {

                    console.log(error);

                    this.spinner.hide();

                    this._validaDNI();



                });
                } else {
                  this.llenarPersonaBusqueda(resultadoMa, tipoDoc, PERSONA_MAESTRA);
                  this.flgDeshabilitaValidar = false;
                }
              }
          }, error => {

              console.log(error);

              this.spinner.hide();

              this._validaDNI();

          });


      // openModalMensajePrg("","",this.dialog,true).subscribe(result=>{

      //   if(result != "")
      //   {



      //   }

      // });


    } else {
      this._validaDNI();

    }

  }


}

llenarPersonaBusqueda(dataPersona, tipoDocumento, tipoServicio) {


  if (tipoServicio == 1) {

    this.strDscNombreCompl = dataPersona.dcLastName1 + ' ' + dataPersona.dcLastName2  + ' ' + dataPersona.dcFirstName;


  } else {

    this.strDscNombreCompl = dataPersona.cpersonaApepaterno + ' ' + dataPersona.cpersonaApematerno  + ' ' + dataPersona.cpersonaNombres;


  }

}

_validaDNI() {

    openModalMensaje('Funcionario', 'Debe ingresar un DNI válido', this.dialog);
    this.flgDeshabilitaValidar = false;


}

  // _mayusculas(e){

  //   var vData = "";

  //   e.target.value = e.target.value.toUpperCase();

  //   vData = e.target.value.trim();

  //   e.target.value = vData;

  //   this.strDscNombreCompl = vData;

  //  }

  _cancelar() {
    this.dialogRef.close(null);
  }

  _aceptarRL() {

    let vPersonaXRepLeg: PersonaXRepLeg = null;

    if ( isEmpty(this.strDscNombreCompl)) {

      openModalMensaje(this.strDscTitulo, 'Ingrese al representante legal, por favor verifique.', this.dialog);

      return false;

    } else if (this.listRL.filter(x => x.cpersonaxrlNombres == this.strDscNombreCompl)[0] != null) {

      openModalMensaje(this.strDscTitulo, 'El representante legal ingresado ya existe, por favor verifique.', this.dialog);

      return false;

    }

    vPersonaXRepLeg = new PersonaXRepLeg();

    vPersonaXRepLeg.cpersonaxrlNombres = this.strDscNombreCompl;

    this.listRL.push(vPersonaXRepLeg);

    this.dialogRef.close({listModalRepLegal: this.listRL});

  }


}
